/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../../../../_metronic/_partials/controls';


import { DonationTable } from './donation-payment-table/DonationPaymentTable';
import { DonationFilter } from './donation-payment-filter/DonationPaymentFilter';
import { DonationUIProvider, useDonationUIContext } from './DonationPaymentUIContext';
import { Collapse, Badge } from 'react-bootstrap';
import { shallowEqual, useSelector } from "react-redux";

export function DonationCard() {

    const donationUIContext = useDonationUIContext();
    const donationUIProps = useMemo(() => {
        return {
            queryParams: donationUIContext.queryParams,
            newDonationButtonClick: donationUIContext.newDonationButtonClick,
        };
    }, [donationUIContext]);

    const [statusFilter, setStatusFilter] = useState(false);
    // const [isDisabled, setIsDisabled] = useState(false);
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('Daftar Donasi Untuk Dipilih')

    const { user } = useSelector(
        (state) => ({ user: state.auth.user }),
        shallowEqual,
    );

    const changeShow = () => {
        setOpen(!open);

        // Set Status Filter To False
        setStatusFilter(false);
        const filter = donationUIProps.queryParams.filter;
        for (const [key, value] of Object.entries(filter)) {
            if (value !== '') {
                setStatusFilter(true);
            }
        }
    };

    const access = ['DataProses', 'AdminCabang', 'SuperAdmin', 'KepalaCabang', 'MitraEchannel']

    return (
        <Card>
            <CardHeader title={title}>

                <CardHeaderToolbar>
                    {statusFilter && (
                        <Badge className="mr-5" pill variant="danger">Filter Aktif</Badge>
                    )}
                    <button
                        type="button"
                        className="btn btn-warning mr-2"
                        onClick={changeShow}
                        aria-controls="collapse-filter-donasi"
                        aria-expanded={open}
                    >Cari
                    </button>

                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Collapse in={open}>
                    <div id="collapse-filter-donasi">
                        <DonationFilter />
                    </div>
                </Collapse>
                <DonationTable />
            </CardBody>
        </Card>
    );
}
